import { graphql } from '@mp/graphql/generated';
import { useGraphQLQuery } from '../../../hooks/useGraphQLRequest';
import { GetProfessionalSaasDetailQuery } from '@mp/graphql/generated/graphql';

const ProfessionalSaasDetailGql = graphql(`
  query GetProfessionalSaasDetail($input: ProfessionalSaasDetailQueryInput) {
    professionalSaasDetails(input: $input) {
      id
      available_job_slot_labels
      company {
        id
      }
      preferences_last_updated_at
      preferences_last_updated_by_account_id
      preferences_last_updated_by_account {
        id
        first_name
        last_name
        company {
          name
        }
      }
      preferred_job_slots {
        id
        label
      }
      preferred_locations {
        id
      }
      preferred_positions {
        id
      }
      preferred_weekly_total_shifts
      preferred_workdays
      professional {
        id
      }
    }
  }
`);

export const useProfessionalSaasDetail = (professionalId: number | undefined) => {
  const enabled = !!professionalId;

  const { data, isLoading } = useGraphQLQuery<GetProfessionalSaasDetailQuery>({
    operationName: 'GetProfessionalSaasDetail',
    query: ProfessionalSaasDetailGql,
    enabled,
    variables: {
      input: {
        filter: { professional_id: professionalId },
      },
    },
  });

  return {
    professionalSaasDetail: data?.professionalSaasDetails?.[0],
    isLoading: enabled ? isLoading : false,
  };
};
